'use client';

import Image from 'next/image';

import type { LandingPageProps } from '../_lib/landing-page.types';

import './styles.css';

export default function FrameLandingPage(_props: LandingPageProps) {
  return (
    <div className="min-h-screen bg-[var(--frame-brown)] flex flex-col items-center justify-center px-6">
      {/* Logo */}
      <div className="frame-animate-fade-in mb-12">
        <Image
          src="/landing-pages/framestudio/images/logo-horizontal-blue.png"
          alt="Frame Studio"
          width={600}
          height={200}
          className="w-64 sm:w-80 md:w-96 lg:w-[28rem] h-auto"
          priority
        />
      </div>

      {/* CTA Button */}
      <div className="frame-animate-fade-in frame-delay-400">
        <a
          href="/membership"
          className="inline-flex items-center justify-center bg-[var(--frame-blue)] text-[var(--frame-brown)] font-semibold text-base sm:text-lg h-12 sm:h-14 px-10 sm:px-12 rounded-full hover:bg-[var(--frame-blue)]/85 transition-colors duration-300 tracking-wide"
        >
          Become a Member
        </a>
      </div>
    </div>
  );
}
